import { useState } from "react";
import { useTranslation } from "react-i18next";
import { usePaymnetContext } from "../..";
import { merchantPaymentAPI, merchantPaymentAPIV2, mnoCheckoutAPI } from "../apiSercive";
import { encryptStringWithRsaPublicKey, generateUUID, getQueryStringValue, IPaymentPartner, PHONE_STATUS, PREVIEW_MODE } from "../common";
import { PaymentFooter } from "../payment.process/payment.process";

const PinConfirmation = ({ selectedPayment, onClose }: { selectedPayment?: IPaymentPartner; onClose: () => void; }) => {
    const { state, update } = usePaymnetContext();
    const [loading, setLoading] = useState<boolean>(false);
    const { t } = useTranslation();
    const pinChange = (e: any) => {
        if (!e.target.value) {
            update({ ...state, pin: { value: "", error: t("requiredField") } })
        } else {
            update({ ...state, pin: { value: e.target.value, error: "" } })
        }
    }

    const approveInApp = (e: React.ChangeEvent<HTMLInputElement>) => {
        update({ ...state, approveInApp: e.target.checked });
    }
    const submit = async () => {
        if (state.mode === PREVIEW_MODE) {
            update({ ...state, phoneStatus: PHONE_STATUS.CONFIRMED })
            return;
        }

        if (state.approveInApp) {
            let modal: any = {
                "provider": selectedPayment?.provider,
                "source": "Checkout Page",
                "amount": state.paymentDetail?.amount,
                "currency": selectedPayment?.currency,
                "accountNumber": state.phone.value,
                "externalId": state.paymentDetail?.externalId,
                "additionalProperties": {
                    "shop": selectedPayment?.vendorName
                }
            }
            const paymentLinkId = getQueryStringValue("id")
            if (paymentLinkId) {
                modal = {
                    ...modal,
                    source: "Lipia Link",
                    paymentLink: {
                        paymentLinkId: paymentLinkId,
                        vendorId: state.paymentDetail?.vendorId
                    }
                }
            }
            setLoading(true);
            mnoCheckoutAPI(modal).then((data) => {
                if (data.success) {
                    update({ ...state, phoneStatus: PHONE_STATUS.CONFIRMED })
                    setLoading(false);
                } else {
                    update({
                        ...state,
                        success: false,
                        systemMessage: {
                            ...state.systemMessage,
                            show: true,
                            title: "error",
                            message: data.message ? data.message : t("unsuccessPayment")
                        }
                    });
                    setLoading(false);
                }
            }).catch((error: any) => {
                setLoading(false);
                update({
                    ...state,
                    success: false,
                    systemMessage: {
                        ...state.systemMessage,
                        show: true,
                        title: error?.code,
                        message: error.message
                    }
                });
            })
        } else {
            if (!state.pin.value) {
                return update({ ...state, pin: { value: "", error: t("requiredField") } })
            }
            setLoading(true);
            update({ ...state, phoneStatus: PHONE_STATUS.CONFIRMATION_INPROGERSS })
            const pin = encryptStringWithRsaPublicKey(state.pin.value, process.env.REACT_APP_PUBLIC_KEY || "")
            // const pin = state.pin.value;
            const modal = {
                transactionAmount: state.paymentDetail?.amount,
                source: state.paymentDetail?.vendorName || state.paymentDetail?.appName,
                language: state.paymentDetail?.language,
                externalReferenceId: state.paymentDetail?.externalId,
                vendorId: selectedPayment?.paymentVendorId,
                paymentLinkId: getQueryStringValue("id") || "00000000-0000-0000-0000-000000000000",
                sender: {
                    idValue: state.phone.value,
                    identificationNo: "4001111333",
                    pin
                }
            }


            merchantPaymentAPIV2(modal).then(data => {
                if (data.status === "Success") {
                    update({ ...state, status: data.status?.toLowerCase(), phoneStatus: PHONE_STATUS.CONFIRMED })
                } else if (data.status === "Failed") {
                    if (data.errors && data.errors.length > 0) {
                        let error = t(data.errors[0]?.code);
                        if (!error) {
                            error = data.errors[0]?.message || data.errors[1]?.message;
                        }
                        update({ ...state, pin: { ...state.pin, error }, phoneStatus: PHONE_STATUS.INVALID_PIN })
                    } else if (data.message) {
                        update({ ...state, pin: { ...state.pin, error: data.message }, phoneStatus: PHONE_STATUS.INVALID_PIN })
                    } else {
                        update({
                            ...state,
                            success: false,
                            systemMessage: {
                                ...state.systemMessage,
                                show: true,
                                title: t("genralErrorTitle"),
                                message: t("someThingWentWrong")
                            }
                        });
                    }
                    setLoading(false);
                }
            }).catch((error: any) => {
                setLoading(false);
                update({
                    ...state,
                    success: false,
                    systemMessage: {
                        ...state.systemMessage,
                        show: true,
                        title: error?.code || error?.title,
                        message: error.message
                    }
                });
            });
        }
    }

    return <>
        <div className="confirmation">
            <div className="phone">
                <span>
                    {state.phone.value}
                </span>
                <div className="circle">
                    <div className="checkmark"></div>
                </div>
            </div>
            <hr className="line" />
            <div className="title">{t("confirmationProcess")}</div>
            <div className="form-field pin-field">
                <div>{t("pinMsg")}</div>
                <input type="password" disabled={loading || state.approveInApp} className={`input-txt ${state.pin.error ? "input-error" : ""}`} value={state.pin.value} onChange={pinChange} />
            </div>
            <div>{t("or")}</div>
            <div className="form-field radio-field">
                <input disabled={loading} type="checkbox" onChange={approveInApp} />
                <span>{t("approve")}</span>
            </div>
        </div>
        <PaymentFooter loading={loading} submitTxt={t("confirm")} onClose={onClose} onSubmit={submit} />
    </>
}

export default PinConfirmation
